import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctor-slots',
  templateUrl: './doctor-slots.component.html',
  styleUrls: ['./doctor-slots.component.scss']
})
export class DoctorSlotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
